import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';
import { StylingService } from 'src/app/services/style-service/styling.service';

@Directive({
  selector: "[customSpinner]",
  standalone:false
})
export class CustomSpinnerDirective implements AfterViewInit{

  constructor(
    private elem: ElementRef,
    private styling: StylingService
  ){}

  ngAfterViewInit(){
    const element = this.elem.nativeElement;
    const circle = element.querySelector("circle");
    circle.style.stroke = this.styling.colorArr[0];
  }
}